import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { MutateSetAttackScenario } from "../../../utils/graphql/hooks/raceDataHooks";

export default function AttackControls({ carColour }: { carColour: string }) {
  const raceConfig = useSelector(
    (state: RootState) => state.raceData[carColour]?.raceConfig,
    isEqual,
  );

  const jagDrivers = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.jagDrivers,
    isEqual,
  );

  const driverInfo = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.driverInfo,
    isEqual,
  );

  const tAttackVsScenario = useSelector(
    (state: RootState) =>
      state.imports.imports.strategy?.data.tAttackVsScenario,
    isEqual,
  );

  const carHighlightColor = useMemo(() => {
    const driverNumber = jagDrivers?.[carColour];
    if (driverNumber && driverInfo?.[driverNumber]?.driverHighlightColourAlt) {
      return driverInfo[driverNumber].driverHighlightColourAlt;
    }
    return "#ffffff";
  }, [jagDrivers, driverInfo, carColour]);

  const setAttackScenario = MutateSetAttackScenario();

  const hasActivated = (raceConfig?.attackActivations?.length ?? 0) > 0;
  const currentScenario = raceConfig?.attackScenario ?? 2;

  const handleScenarioChange = (scenario: number) => {
    if (scenario !== currentScenario) {
      setAttackScenario({ variables: { carColour, attackScenario: scenario } });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.attackScenarioContainer}>
        <>
          {tAttackVsScenario?.map((times, index) => {
            const scenario = index + 1;
            const label = times
              .map((time) => `${Number((time / 60).toFixed(1))}`)
              .join(" - ");
            return (
              <label key={scenario} className={styles.radioOption}>
                <input
                  type="radio"
                  name={`attackScenario-${carColour}`}
                  disabled={hasActivated}
                  checked={currentScenario === scenario}
                  onChange={() => handleScenarioChange(scenario)}
                />
                <span
                  style={
                    currentScenario === scenario
                      ? { color: carHighlightColor }
                      : undefined
                  }
                >
                  {label}
                </span>
              </label>
            );
          })}
        </>
      </div>
    </div>
  );
}
